import React from 'react'

export default function Footer() {

    return (

        <div>
            <nav class=" fixed-bottom navbar navbar-expand-md navbar-light bg-light">
                <div class="navbar-collapse collapse w-100 order-3 dual-collapse2">
                    <ul class="navbar-nav ml-auto">
                        <li class="nav-item">
                            <a class="nav-link" href="/">J&M Enterpirses 2020</a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>

    )
}

